module.exports = __webpack_public_path__ + "img/logo.b168a30f.png";